import { useIsSuperReaderUser } from '../../../hooks/permissions/useIsSuperReaderUser';
import { useCommonTranslation } from '../../../hooks/useCommonTranslation';
import PageHeader from '../../controls/PageHeader';

interface ClientHeaderProps {
  name: string;
  isOnboarding: boolean;
}

export default function ClientHeader({
  name,
  isOnboarding,
}: ClientHeaderProps) {
  const t = useCommonTranslation();
  const title = isOnboarding ? `${name} (${t('client.onboarding')})` : name;

  const isSuperReaderUser = useIsSuperReaderUser();

  const onSubmitClient = () => {
    // TODO: implement this
  };

  return (
    <PageHeader
      title={title}
      returnLink="/clients"
      returnLinkText={t('client.clients')}
      primaryActionText={!isSuperReaderUser ? t('common.submit') : undefined}
      primaryActionDisabled={true}
      onPrimaryAction={!isSuperReaderUser ? onSubmitClient : undefined}
    />
  );
}
